<template>
    <div>
        <side-menu />
        <loading-screen v-if="loadingScreen" />
        <section class="container profile-container">
            <div class="profile">
                <h1>Devolutivas</h1>
                <div class="card no-mobile">
                    <div class="card-header">

                    </div>
                    <div class="card-body">
                        <div class="card-table">
                            <table>
                                <thead>
                                    <tr class="t-row">
                                        <th>
                                            Nº Kit
                                        </th>
                                        <th>
                                            Tipo de KIT
                                        </th>
                                        <th>
                                            Resultado
                                        </th>
                                        <th>
                                            Devolutiva
                                        </th>
                                        <th>
                                            Data de conclusão
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="!loadingScreen && results.length === 0">
                                        <td colspan="8" class="td">Não foram encontrados devolutivas</td>
                                    </tr>
                                    <tr v-for="result in results" v-bind:key="result.kit_id" >
                                        <td class="td">
                                            {{result.kit.number}}
                                        </td>
                                        <td class="td">
                                            {{result.kit.kit_type.name}}
                                        </td>
                                        <td class="td">
                                            {{result.result.value}}
                                        </td>
                                        <td class="td">
                                            <a :href="result.annex.url" target="_blank">Baixar</a>
                                        </td>
                                        <td class="td">
                                            {{getDate(result.annex.created_at)}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">

                    </div>
                </div>
                <div class="cards">
                    <div class="card mobile" v-if="!loadingScreen && results.length === 0">
                        <div class="card-details">
                            <div class="detail">
                                Não foram encontrados devolutivas
                            </div>
                        </div>
                    </div>
                    <div class="card mobile" v-for="result in results" v-bind:key="result.kit_id">
                        <div class="card-details">
                            <div class="detail">
                                <h5>Nº Kit</h5>
                                <span>{{result.kit.number}}</span>
                            </div>
                            <div class="detail">
                                <h5>Tipo de KIT</h5>
                                <span>{{result.kit.kit_type.name}}</span>
                            </div>
                            <div class="detail">
                                <h5>Resultado</h5>
                                <span>{{result.result.value}}</span>
                            </div>
                            <div class="detail">
                                <h5>Devolutiva</h5>
                                <span><a :href="result.annex.url" target="_blank">Baixar</a></span>
                            </div>
                            <div class="detail">
                                <h5>Data de conclusão</h5>
                                <span>{{getDate(result.annex.created_at)}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { LIST_RESULTS } from '../../services/result'

    export default {
        components: { },
        data() {
            return {
                loading: false,
                loadingScreen: false,
                results: {},
            }
        },
        methods: {
            async getReturns() {
                this.loadingScreen = true;
                try{
                    const response = await LIST_RESULTS();
                    if(response) {
                        this.results = response;
                    }
                } catch(error) {

                } finally {
                    this.loadingScreen = false;
                }
            },
            getDate(date) {
                date = new Date(date);
                date = (this.aditionalZero(date.getDate()) ) + "/" + ((this.aditionalZero(date.getMonth() + 1))) + "/" + date.getFullYear();
                return date;
            },
            aditionalZero(number) {
                if (number <= 9) 
                    return "0" + number;
                else
                    return number; 
            }
        },
        mounted() {
            this.getReturns()
        }
    }
</script>

<style scoped>
  @import "./returns.scss";
  @import "../Profile/responsive.css";
  @import "../Schedules/responsive.css";
</style>



// WEBPACK FOOTER //
// src/views/Returns/Returns.vue